// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-section {
    position: relative;
    z-index: 0;
}

.edit-panel {
    padding: 20px;
    border-radius: 8px;
    width: 450px;
    max-width: 100%;
    min-height: 380px;
    max-height: 100%;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
}

.overlay {
    position: fixed;
    background-color: #d8dce5;
    top: 0;
    left: 0;
    transform: translate(6%, 150px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.group-dropdown {
    position: relative;
    margin-bottom: 10px;
}

.group-dropdown select {
    width: 100%;
    color: #000;
    border: 1px solid #ccc;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.edit-panel label {
    display: block;
    margin-top: 10px;
    margin-bottom: 5px;
    color: #000;
}

.edit-panel select {
    margin-bottom: 10px;
    width: 100%;
    height: 35px;
    color: #000;
    border: 1px solid #ccc;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/Edit.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,MAAM;IACN,OAAO;IACP,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB","sourcesContent":[".edit-section {\n    position: relative;\n    z-index: 0;\n}\n\n.edit-panel {\n    padding: 20px;\n    border-radius: 8px;\n    width: 450px;\n    max-width: 100%;\n    min-height: 380px;\n    max-height: 100%;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);\n}\n\n.overlay {\n    position: fixed;\n    background-color: #d8dce5;\n    top: 0;\n    left: 0;\n    transform: translate(6%, 150px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n}\n\n.group-dropdown {\n    position: relative;\n    margin-bottom: 10px;\n}\n\n.group-dropdown select {\n    width: 100%;\n    color: #000;\n    border: 1px solid #ccc;\n    background-color: #fff;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.edit-panel label {\n    display: block;\n    margin-top: 10px;\n    margin-bottom: 5px;\n    color: #000;\n}\n\n.edit-panel select {\n    margin-bottom: 10px;\n    width: 100%;\n    height: 35px;\n    color: #000;\n    border: 1px solid #ccc;\n    background-color: #fff;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
